import { render, staticRenderFns } from "./salaryFixationView.vue?vue&type=template&id=2b9988c0"
import script from "./salaryFixationView.vue?vue&type=script&lang=js"
export * from "./salaryFixationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports